var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgGameType(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.863 3.924H4.137C2.405 3.924 1 5.302 1 7.002v10.916c0 1.7 1.405 3.078 3.137 3.078h15.726c1.732 0 3.137-1.378 3.137-3.078V7.002c0-1.7-1.405-3.078-3.137-3.078z",
    fill: "#2E3133"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6.078V16.99c0 .817-.33 1.6-.919 2.178a3.172 3.172 0 01-2.218.904H4.137a3.172 3.172 0 01-2.218-.904A3.052 3.052 0 011 16.99V6.078c0-.817.33-1.6.919-2.177A3.168 3.168 0 014.137 3h15.726a3.162 3.162 0 011.559.413c.473.27.866.658 1.138 1.124.285.465.437.998.44 1.54z",
    fill: "#454A4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.955 4.26H4.045c-1.048 0-1.897.833-1.897 1.86v4.48c0 1.028.85 1.861 1.897 1.861h15.91c1.048 0 1.897-.833 1.897-1.86V6.12c0-1.028-.85-1.861-1.897-1.861z",
    fill: "#B3F2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.284 16.874l2.556 1.86a.89.89 0 001.233-.246.852.852 0 00.14-.431v-3.72a.852.852 0 00-.14-.432.893.893 0 00-1.233-.246l-2.556 1.86a.867.867 0 00-.335.678.85.85 0 00.335.677z",
    fill: "#3BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.718 16.874l-2.556 1.86a.891.891 0 01-1.233-.246.851.851 0 01-.14-.431v-3.72a.851.851 0 01.14-.432.893.893 0 011.233-.246l2.556 1.86a.868.868 0 01.335.678.85.85 0 01-.335.677z",
    fill: "#F33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.76 16.195c0-1.495-1.235-2.707-2.759-2.707-1.524 0-2.759 1.212-2.759 2.707 0 1.494 1.235 2.706 2.759 2.706 1.524 0 2.759-1.212 2.759-2.706z",
    fill: "#8A9599"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.752 16.197c0-.95-.784-1.718-1.75-1.718-.968 0-1.752.769-1.752 1.718 0 .948.784 1.718 1.751 1.718.967 0 1.751-.77 1.751-1.718z",
    fill: "#C2C9CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.964 4.26L11.72 12.46H6.094l7.242-8.201h5.628z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 3)",
    d: "M0 0h22v18H0z"
  })))));
}
export default SvgGameType;